import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import "./CurrentMonthTaskForm.css";
import CustomNavbar from "../../CustomPermissions/CustomNavbar";
import { getApiUrl } from "../../../config/api";

function CurrentMonthDocladderTaskForm() {
  const { leaderId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    leader: leaderId,
    target: '',
    points: ''
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Clear messages when user types
    setSuccessMessage('');
    setErrorMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const response = await fetch(getApiUrl('/Docladder/create_task/'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Failed to add task');
      }

      setSuccessMessage('✅ Task added successfully! Redirecting...');
      setFormData({
        name: '',
        leader: leaderId,
        target: '',
        points: ''
      });

      // Redirect to tasks page after 2 seconds
      setTimeout(() => {
        navigate(`/membersTask/${leaderId}`);
      }, 2000);

    } catch (error) {
      console.error('Error:', error);
      setErrorMessage(error.message || 'Failed to add task. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(`/membersTask/${leaderId}`);
  };

  return (
    <div style={{ display: "flex" }}>
      <CustomNavbar />
      <div className="create-task-container" style={{ width: "100%", padding: "20px" }}>
        <div className="create-task-card">
          <div className="card-header">
            <h2>
              <i className="fa-solid fa-plus-circle"></i> Create New Task
            </h2>
            <p>Add a new task for the Docladder member</p>
          </div>

          {/* Success Message */}
          {successMessage && (
            <div className="alert alert-success">
              {successMessage}
            </div>
          )}

          {/* Error Message */}
          {errorMessage && (
            <div className="alert alert-error">
              <i className="fa-solid fa-exclamation-circle"></i> {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="task-form">
            <div className="form-group">
              <label htmlFor="name">
                <i className="fa-solid fa-tasks"></i> Task Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g., Candidate Placement Target"
                required
                disabled={loading}
              />
              <small>Enter a descriptive name for the task</small>
            </div>

            <div className="form-group">
              <label htmlFor="leader">
                <i className="fa-solid fa-user"></i> Member ID
              </label>
              <input
                type="text"
                id="leader"
                name="leader"
                value={leaderId}
                disabled
                className="disabled-input"
              />
              <small>This task will be assigned to member #{leaderId}</small>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="target">
                  <i className="fa-solid fa-bullseye"></i> Target *
                </label>
                <input
                  type="number"
                  id="target"
                  name="target"
                  value={formData.target}
                  onChange={handleChange}
                  placeholder="e.g., 15"
                  step="0.01"
                  min="0"
                  required
                  disabled={loading}
                />
                <small>Target value to achieve</small>
              </div>

              <div className="form-group">
                <label htmlFor="points">
                  <i className="fa-solid fa-star"></i> Points *
                </label>
                <input
                  type="number"
                  id="points"
                  name="points"
                  value={formData.points}
                  onChange={handleChange}
                  placeholder="e.g., 75"
                  step="0.01"
                  min="0"
                  required
                  disabled={loading}
                />
                <small>Points awarded on completion</small>
              </div>
            </div>

            <div className="form-actions">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fa-solid fa-spinner fa-spin"></i> Creating...
                  </>
                ) : (
                  <>
                    <i className="fa-solid fa-plus"></i> Create Task
                  </>
                )}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
                disabled={loading}
              >
                <i className="fa-solid fa-times"></i> Cancel
              </button>
            </div>
          </form>

          <div className="card-footer">
            <p>
              <i className="fa-solid fa-info-circle"></i> Fields marked with * are required
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CurrentMonthDocladderTaskForm;
